import { TDocumentType } from '@/@types/document-type';
import { api } from '@/services/apiClient';
import { useQuery } from '@tanstack/react-query';

interface GetDocumentTypeProps {
  id?: string;
}

type GetDocumentTypeResponse = TDocumentType;

export async function getDocumentType({
  id,
}: GetDocumentTypeProps): Promise<GetDocumentTypeResponse> {
  const { data } = await api.get(`/document_types/${id}`);

  return {
    ...data,
    affectsCashMovement: data.affects_cash_movement,
  };
}

export function useGetDocumentType({ id }: GetDocumentTypeProps) {
  return useQuery({
    queryKey: ['documentTypes', id],
    queryFn: () => getDocumentType({ id }),
    enabled: !!id,
    staleTime: 1000 * 60 * 1, // 1 minute
  });
}
